import { STRING_getInstance7xungxdjbzv as STRING_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import {
  Companion_getInstance3h03aipe2gus4 as Companion_getInstance,
  LocalDate31mqn6zavbpi8 as LocalDate,
} from '../LocalDate.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LocalDateSerializerClass;
function LocalDateSerializer() {
  if (LocalDateSerializerClass === VOID) {
    class $ {
      constructor() {
        LocalDateSerializer_instance = this;
        this.descriptor_1 = PrimitiveSerialDescriptor('kotlinx.datetime.LocalDate', STRING_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      deserialize_sy6x50_k$(decoder) {
        return Companion_getInstance().parse$default_krgov1_k$(decoder.decodeString_x3hxsx_k$());
      }
      serialize_cgw3bx_k$(encoder, value) {
        encoder.encodeString_424b5v_k$(value.toString());
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_cgw3bx_k$(encoder, value instanceof LocalDate() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'LocalDateSerializer', VOID, VOID, [KSerializer()]);
    LocalDateSerializerClass = $;
  }
  return LocalDateSerializerClass;
}
var LocalDateSerializer_instance;
function LocalDateSerializer_getInstance() {
  if (LocalDateSerializer_instance === VOID)
    new (LocalDateSerializer())();
  return LocalDateSerializer_instance;
}
//region block: exports
export {
  LocalDateSerializer_getInstance as LocalDateSerializer_getInstance3qg2c8779i3ej,
};
//endregion

//# sourceMappingURL=LocalDateSerializers.mjs.map
